module.exports = __webpack_public_path__ + "img/Führungsgruppe.86a51c01.svg";